import React, { useEffect, useState } from "react";
import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";
import "../assets/css/TermsConditions.css";

const TermsConditions = () => {
  //const { languageId } = useLanguage();
const { language } = useLanguage();
const languageId = language?.lang_id || 1;
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await api.get("/contents/content", {
          params: {
            page_id: 20,
            lang_id: languageId || 1,
          },
        });

        if (response.data?.success && response.data?.data) {
          setContent(response.data.data);
        } else {
          setError("Unable to load the terms and conditions.");
        }
      } catch (err) {
        console.error("Terms API Error:", err);

        setError(
          err.response?.data?.message ||
            "Unable to load the terms and conditions."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, [languageId]);

  return (
    <div className="terms-page">

      {/* =========================================
          PAGE HEADER
      ========================================= */}
	  <div className="bg-box ">
      <section className="modify1 terms-header">
        <div className="terms-container">
          <div className="terms-header-inner">

          

            <div>
              <div className="terms-eyebrow">
                IMPORTANT INFORMATION
              </div>

              <h1>
                {content?.cont_title || "Terms & Conditions"}
              </h1>

              <p>
                Please review our rental terms and conditions
                before completing your booking.
              </p>
            </div>

          </div>
        </div>
      </section></div>

      {/* =========================================
          CONTENT
      ========================================= */}
      <main className="terms-main">
        <div className="terms-container">

          {loading && (
            <div className="terms-loading">
              <div className="terms-spinner"></div>
              <span>Loading terms and conditions...</span>
            </div>
          )}

          {!loading && error && (
            <div className="terms-error">
              <div className="terms-error-icon">
                <i className="bi bi-exclamation-triangle"></i>
              </div>

              <div>
                <h3>Unable to load content</h3>
                <p>{error}</p>
              </div>
            </div>
          )}

          {!loading && !error && content && (
            <article className="terms-card">

              <div className="terms-card-top">
                <div className="terms-card-label">
                  <span></span>
                  RENTAL TERMS
                </div>
              </div>

              <div
                className="terms-content"
                dangerouslySetInnerHTML={{
                  __html: content.cont_details || "",
                }}
              />

            </article>
          )}

        </div>
      </main>

    </div>
  );
};

export default TermsConditions;